import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { LOGIN_EMAIL_ROUTE } from ".";
import { Button } from "../_components/button.component";
import { history } from "../_config/history.config";
import { mixPanel } from "../_config/mixpanel.config";
import { COMMUNITY_HOMEPAGE_ROUTE } from "./community-home/community-home.page";

export const APP_SUMO_SUCCESS_ROUTE = "/app-sumo";

function AppSumoSuccessPageComponent({ user }) {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  return (
    <div className="flex h-screen">
      <div className="m-auto theme-bg-surface drop-shadow-lg rounded-md p-8">
        <div className="flex w-max m-auto text-2xl theme-text-heading-2 p-6 ">
          Congratulations! 🎉
        </div>
        <div className="text-base font-semibold theme-text-heading-2 py-4">
          You have successfully bought Pensil platform from AppSumo
        </div>
        <div className="text-base theme-text-heading-2 ">
          {" "}
          Please follow these steps to redeem
        </div>
        <div className="py-0.5 px-0.5 rounded text-base theme-text-subtitle-1 hover:theme-bg-default">
          1. Login from <b>'{email}'</b> id
        </div>
        <div className="py-0.5 px-0.5 rounded text-base theme-text-subtitle-1 hover:theme-bg-default">
          {" "}
          2. Go to your community or create community (
          {
            <a href="https://www.pensil.in/post/how-to-start-an-online-community-forum">
              learn to create community
            </a>
          }
          )
        </div>
        <div className="py-0.5 px-0.5 rounded text-base theme-text-subtitle-1 hover:theme-bg-default">
          {" "}
          3. Go to 'Settings' by clicking on the profile in the top right corner
        </div>
        <div className="py-0.5 px-0.5 rounded text-base theme-text-subtitle-1 hover:theme-bg-default">
          {" "}
          4. Go to 'Subscription' in setting page
        </div>
        <div className="py-0.5 px-0.5 rounded text-base theme-text-subtitle-1 hover:theme-bg-default">
          {" "}
          5. Click on 'Redeem' in the on the available plan
        </div>
        {/* login button */}
        <div className="flex justify-center mt-8 flex-col text-center">
          {user ? (
            user.email + "3" !== email ? (
              <>
                <div className="text-base theme-text-heading-2">
                  {" "}
                  You are not logged in as <b>{email}</b>
                </div>
                <div className="flex justify-center mt-5">
                  <Button
                    label="Login"
                    onClick={() => {
                      // clear the session
                      localStorage.removeItem("pensil.user");
                      mixPanel.reset();
                      window.location.reload();
                    }}
                  />
                </div>
              </>
            ) : (
              <Button
                label="Go to home"
                onClick={() => {
                  history.push(COMMUNITY_HOMEPAGE_ROUTE);
                }}
              />
            )
          ) : (
            <Button
              label="Login"
              onClick={() => {
                history.push(LOGIN_EMAIL_ROUTE + `?email=${email}`);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (s) => ({ user: s.auth });
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const AppSumoSuccessPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppSumoSuccessPageComponent);

export default AppSumoSuccessPage;
